<template>
  <div class="modal right fade trader-info" id="trader-info" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div style="max-width:1420px" class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header" style="justify-content: end;">
          <div class="hint-color">
            <div>
              <span class="row-highlight-red"><i class="fa fa-square-o"></i></span>
              <span class="hint" data-toggle="tooltip" data-placement="left"
                title="There is a discrepancy between System calculated commission and imported commission.">
                <i class="fa fa-info-circle"></i>
              </span>
            </div>
            <div>
              <span class="row-highlight-orange"><i class="fa fa-square-o"></i></span>
              <span class="hint" data-toggle="tooltip" data-placement="left"
                title="This sell is not completely settled. Thus, there could be change in calculated commission.">
                <i class="fa fa-info-circle"></i>
              </span>
            </div>
            <div>
              <span class="row-highlight-grey"><i class="fa fa-square-o"></i></span>
              <span class="hint" data-toggle="tooltip" data-placement="left" title="This sell is not in range.">
                <i class="fa fa-info-circle"></i>
              </span>
            </div>
          </div>
          <button v-if="buyData.hasManualMapping" style="right: 30px;" type="button" @click="removeManualMapping()"
            class="btn btn-danger btn-sm position-absolute mr-4">Remove Manual Mapping</button>
          <button type="button" class="close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h3 class="trade-title">BUY</h3>
          <table class="table align-items-center table-flush table-hover bidtbl">
            <thead class="thead-light psticky">
              <tr>
                <th></th>
                <th>CUSIP</th>
                <th>ACCOUNT <br> NO</th>
                <th>BUY/SELL </th>
                <th>TRADE<br> DATE</th>
                <th>SETTLEMENT<br> DATE</th>
                <th>QTY</th>
                <th>PRICE</th>
                <th>PRINCIPAL<br> AMOUNT</th>
                <th>INTEREST</th>
                <th>COMMCON <br>AMOUNT</th>
                <th>REF<br> NO</th>
                <th>ACCOUNT<br> TYPE</th>
                <th>EXEC<br>BROKER <br>MINOR</th>
                <th>Security <br> Type</th>
                <th>RR1</th>
                <th class="border-right">FBSI <br>SHORT <br>NAME</th>
                <th>SETTLED</th>
                <th>TRADER</th>
              </tr>
            </thead>
            <tbody>
              <tr v-bind:class="{ 'row-highlight-red': buyData.highlight }">
                <td class="text-center">
                  <span v-if="highlightMinDenomBreach && buyData.isMinDenomIrregular" data-toggle="tooltip"
                    data-placement="left" title="Irregular Minimum Denomination ">
                    <i class="fa fa-exclamation-triangle" style="color: #ff1b1b; font-size: 13px;"></i>
                  </span>
                </td>
                <td class="text-center">
                  <span :class="getClass(buyData)">
                    <span data-toggle="tooltip" data-placement="left" title="Below Minimum Denomination"
                      v-if="buyData.isBelowMinDenom">{{ data.cusip }}</span>
                    <span v-if="!buyData.isBelowMinDenom">{{ buyData.cusip }}</span>
                  </span>
                </td>
                <td class="text-center">{{ buyData.accountNo }}</td>
                <td class="text-center">{{ buyData.actionSb }}</td>
                <td class="text-center">{{ moment(buyData.tradeDate).format("MM/DD/YYYY") }}</td>
                <td class="text-center">{{ moment(buyData.settlementDate).format("MM/DD/YYYY") }}</td>
                <td class="text-center">{{ buyData.quantity }}</td>
                <td class="text-center">{{ buyData.price | currency }}</td>
                <td class="text-center">{{ buyData.principalAmnt | currency }}</td>
                <td class="text-center">{{ buyData.interest | currency }}</td>
                <td class="text-center">{{ buyData.commConcAmount | currency }}</td>
                <td class="text-center">{{ buyData.referenceNo }}</td>
                <td class="text-center">{{ buyData.acctType }}</td>
                <td class="text-center">{{ buyData.execBrokerMinor }}</td>
                <td class="text-center">{{ buyData.securityType }}</td>
                <td class="text-center">{{ buyData.repCode }}</td>
                <td class="text-center border-right">{{ buyData.fbsiShortName }}</td>
                <td class="text-center">{{ buyData.settled }}</td>
                <td class="text-center">{{ buyData.firstName }}</td>
              </tr>
            </tbody>
          </table>
          <h3 class="trade-title">SELL</h3>
          <table class="table align-items-center table-flush table-hover bidtbl">
            <thead class="thead-light psticky">
              <tr>
                <th></th>
                <th scope="col" class="sort text-center">CUSIP</th>
                <th scope="col" class="sort text-center">ACCOUNT<br> NO</th>
                <th scope="col" class="sort text-center">BUY/<br>SELL </th>
                <th scope="col" class="sort text-center">TRADE <br> DATE</th>
                <th scope="col" class="sort text-center">SETTLEMENT <br> DATE</th>

                <th scope="col" class="sort text-center">QTY</th>
                <th scope="col" class="sort text-center">PRICE</th>
                <th scope="col" class="sort text-center">PRINCIPAL <br> AMOUNT</th>
                <th scope="col" class="sort text-center">INTEREST</th>
                <th scope="col" class="sort text-center">COMMCON <br>AMOUNT</th>
                <th scope="col" class="sort text-center">REF NO</th>
                <!-- <th 
                scope="col" 
                class="sort text-center"
                >PRIMARY ACCOUNT HOLDER</th> -->
                <th scope="col" class="sort text-center">ACCOUNT <br> TYPE</th>
                <th scope="col" class="sort text-center">EXEC<br>BROKER <br> MINOR</th>
                <th scope="col" class="sort text-center">Security <br> Type</th>
                <th scope="col" class="sort text-center">RR1</th>
                <th scope="col" class="sort text-center border-right">FBSI<br>SHORT <br> NAME</th>
                <th scope="col" class="sort text-center">SPREAD</th>
                <th scope="col" class="sort text-center">PROFIT</th>
                <th scope="col" class="sort text-center">SETTLED</th>

              </tr>
            </thead>
            <tbody>
              <tr v-if="sellData.length == 0">
                <td>
                  <p class="nodata">No data available</p>
                </td>
              </tr>
              <tr v-for="data in sellData" :key="data.id"
                v-bind:class="{ 'border-highlight': data.isManuallyMapped, 'row-highlight-red': data.highlight, 'row-highlight-orange': data.notFullySettledHighlight, 'row-highlight-grey': data.notInRange }">
                <td class="text-center">
                  <span v-if="highlightMinDenomBreach && data.isMinDenomIrregular" data-toggle="tooltip"
                    data-placement="left" title="Irregular Minimum Denomination ">
                    <i class="fa fa-exclamation-triangle" style="color: #ff1b1b; font-size: 13px;"></i>
                  </span>
                </td>
                <td class="text-center">

                  <span :class="getClass(data)">
                    <span data-toggle="tooltip" data-placement="left" title="Below Minimum Denomination"
                      v-if="data.isBelowMinDenom">{{ data.cusip }}</span>
                    <span v-if="!data.isBelowMinDenom">{{ data.cusip }}</span>
                  </span>
                </td>
                <td class="text-center">{{ data.accountNo }}</td>
                <td class="text-center">{{ data.actionSb }}</td>
                <td class="text-center">{{ moment(data.tradeDate).format("MM/DD/YYYY") }}</td>
                <td class="text-center">{{ moment(data.settlementDate).format("MM/DD/YYYY") }}</td>
                <td class="text-center">{{ data.quantity }}</td>
                <td class="text-center">{{ data.price | currency }}</td>
                <td class="text-center">{{ data.principalAmnt | currency }}</td>
                <td class="text-center">{{ data.interest | currency }}</td>
                <td class="text-center">{{ data.commConcAmount | currency }}</td>
                <td class="text-center">{{ data.referenceNo }}</td>
                <!-- <td class="text-center">{{data.primaryAcctHolder}}</td> -->
                <td class="text-center">{{ data.acctType }}</td>
                <td class="text-center">{{ data.execBrokerMinor }}</td>
                <td class="text-center">{{ data.securityType }}</td>
                <td class="text-center">{{ data.repCode }}</td>
                <td class="text-center border-right">{{ data.fbsiShortName }}</td>
                <td class="text-center">{{ data.calculatedSpread }}</td>
                <td class="text-center">{{ data.calculatedProfit | currency }}</td>
                <td class="text-center">{{ data.settled }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
export default {
  name: 'plSellmodal',
  components: {

  },
  props: ['sellData', 'buyData', 'highlightMinDenomBreach'],
  data() {
    return {


    };
  },
  methods: {
    removeManualMapping() {
      this.getPLRemapStatus().then((result) => {
        if (result.data.remapOngoing) {
          this.$alert(this.appMessages.plRemapMessage, "", "warning");
        } else {
          var message = "Remove manual mappings for this buy? System will automatically assign new mappings automatically on removal.";
          var postData = {
            "buyId": this.buyData.id,
            "cognitoSub": authService.getUser().cognitoSub
          };
          this.$confirm(message, "", "question", { confirmButtonText: "Yes", cancelButtonText: "No" }).then(() => {
            const auth = {
              headers: { 'org-token': authService.getOrgToken() }
            };
            this.loading = true;
            this.$http
              .post(
                config.baseUrlAutoBidder +
                "/pnl/remove-manual-mapping", postData,
                auth
              )
              .then(() => {
                this.loading = false;
                this.$alert("Removed manual mappings.", "", "success");
              })
          })

        }
      });
    },
    getClass(data) {
      const classObj = {
        'min-denom-below': data.isBelowMinDenom,
        //'ml-4': !data.isMinDenomIrregular,
        // 'min-denom-both': data.isMinDenomIrregular && data.isBelowMinDenom,
      };
      if (this.highlightMinDenomBreach)
        return classObj;
    },
  }
};
</script>
<style scoped>
.hint-color {
  display: flex;
  flex-direction: row;
}

.hint-color div {
  text-align: left;
  font-size: 17px;
  font-weight: 900;
}

.hint-color .hint {
  padding: 5px;
  color: red
}

.hint-color i {
  color: #0087D4;
  font-size: 17px;
}

.trade-title {
  color: #638ea7;
}

.border-highlight {
  border: 2px solid #638ea7;
}
</style>